import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import sentry from "utils/sentry";
import { camelCaseKeys } from "utils/transform-object-keys";

import "core";
import "core.css";

import JobListing from "screens/job-listing/job-listing";

import SentryBoundary from "components/libraries/sentry-boundary";

document.addEventListener("DOMContentLoaded", () => {
  const listingContainer = document.getElementById("job-listing");

  if (listingContainer) {
    const root = createRoot(listingContainer);
    const props = camelCaseKeys(JSON.parse(listingContainer.dataset.props));

    root.render(
      <StrictMode>
        <SentryBoundary sentry={sentry}>
          <JobListing {...props} />
        </SentryBoundary>
      </StrictMode>,
    );
  }
});
